// 自定义字段的类型
export enum FieldType {
  text = 'text', // 单行文本输入
  textarea = 'textarea', // 多行文本输入

  select = 'select', // 下拉单选
  select_multiple = 'select_multiple', // 下拉多选
  select_group = 'select_group', // 下拉分组
  advanced_select = 'advanced_select', // 下拉单选 选中项置顶
  advanced_select_multiple = 'advanced_multiple', // 下拉多选 选中项置顶
  tree_select = 'tree_select',

  checkbox = 'checkbox', // 单选：2-4个选项适宜
  radio = 'radio', // 单选：2-4个选项适宜
  switch = 'switch', // 开关：两项

  user_chooser = 'user_chooser', // 人名组件 (单选)
  user_chooser_multiple = 'user_chooser_multiple', // 人名组件 (多选)

  date = 'date', // 日期 (年月日)
  date_range = 'date_range', //  日期范围 (年月日)
  date_multiple = 'date_multiple', // 日期多选

  cascader = 'cascader', // 级联
  cascader_multiple = 'cascader_multiple', // 级联多选
}

// 自定义字段的值类型
export enum FieldValueType {
  number = 'number', // 数字
  str = 'str', // 字符串
  arr = 'arr', // 数组字符串。如果是日期范围（第一项是开始、第二项是结束）
  json = 'json', // json字符串
  boolean = 'boolean', // true false
  url = 'url', // 链接类型，关联 IProjectExtraValueExtensionLink
}
